import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetCategoriaFinanceiraResponse, GetLookupsCategoriaFinanceiraResponse, ListCategoriaFinanceiraResponse } from '../../responses/financas/categoria-financeira.response';
import { CategoriaFinanceiraRequest } from '../../requests/financas/categoria-financeira.request';
import { MoverCategoriaFinanceiraRequest } from '../../requests/financas/mover-categoria-financeira.request';
import { DeletarCategoriaFinanceiraRequest } from '../../requests/financas/deletar-categoria-financeira.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class CategoriaFinanceiraService extends CommonService {
    private readonly apiUrl: string = environment.urlApiFinancas + 'CategoriaFinanceira';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(descricao: string = '', pagina: number = 0, tamanhoPagina: number = 20): Observable<ListCategoriaFinanceiraResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (descricao) {
            params = params.set('descricao', descricao);
        }

        return this.httpClient
            .get<ListCategoriaFinanceiraResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<GetCategoriaFinanceiraResponse> {
        const url = `${this.apiUrl}/idCategoriaFinanceira/${id}`;
        return this.httpClient
            .get<GetCategoriaFinanceiraResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getLookups(): Observable<GetLookupsCategoriaFinanceiraResponse> {
        const url = `${this.apiUrl}/lookups`;
        return this.httpClient
            .get<GetLookupsCategoriaFinanceiraResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public create(request: CategoriaFinanceiraRequest): Observable<GetCategoriaFinanceiraResponse> {
        return this.httpClient
            .post<GetCategoriaFinanceiraResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: CategoriaFinanceiraRequest): Observable<GetCategoriaFinanceiraResponse> {
        const url = `${this.apiUrl}/idCategoriaFinanceira/${id}`;
        return this.httpClient
            .put<GetCategoriaFinanceiraResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deletar(request: DeletarCategoriaFinanceiraRequest): Observable<ReturnStruct> {
        return this.httpClient
            .delete<ReturnStruct>(this.apiUrl, { ...this.addHeaderToken(), body: request })
            .pipe(catchError(this.handleError));
    }

    public moverEmLote(request: MoverCategoriaFinanceiraRequest): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/MoverEmLote`;
        return this.httpClient
            .put<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
